/**
 * Route: `/off-page-briefs` — Off-Page Brief index page.
 *
 * Delegates to the feature-scoped `<OffPageBriefsIndex>`. When the tenant's
 * `a10_off_page_brief` feature flag is off, the sidebar hides the nav item
 * entirely — but a bookmarked/typed URL should still land somewhere friendly,
 * so we render a fail-closed "not available" empty state here.
 */
import { Megaphone } from 'lucide-react';
import { Page } from '@/components/ui/page';
import { EmptyState } from '@/components/ui/empty';
import { useFeatureFlag } from '@/lib/feature-flags';
import { OffPageBriefsIndex } from '@/features/off-page-briefs/components';

export function OffPageBriefsRoute(): JSX.Element {
  const enabled = useFeatureFlag('a10_off_page_brief');
  if (!enabled) {
    return (
      <Page>
        <EmptyState
          icon={Megaphone}
          title="This feature is not available"
          description="Off-Page Brief is not enabled for your workspace. Talk to your admin if you think this is a mistake."
        />
      </Page>
    );
  }
  return <OffPageBriefsIndex />;
}
